import style from "./Description.module.scss"
interface Props {
    description?: string
}

export const Description = ({  description}: Props) => {
    return <p className={style.Description}>{description}</p>
}